import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isRegExp.js
// module id = 208
// module chunks = 0 1